// Transaction entity/model reference
// This file contains the transaction schema structure for reference

export const transactionSchema = {
  _id: String,
  player_name: { type: String, required: true },
  phone: { type: Number },
  items: [{
    game_id: { type: String, required: true },
    name: { type: String, required: true },
    quantity: { type: Number, default: 1 },
    totalparticipants: { type: Number, default: 1 },
    duration: { type: Number },
    price: { type: Number, required: true }
  }],
  subtotal: { type: Number, required: true },
  discount_amount: { type: Number, default: 0 },
  discount_percentage: { type: Number, default: 0 },
  total: { type: Number, required: true },
  gameplayed: { type: Boolean, default: false },
  payment_status: { type: String, enum: ['paid', 'pending'], default: 'pending' },
  payment_source: { type: String, enum: ['cash', 'online'], default: 'cash' },
  invoice_number: { type: String },
  createdAt: { type: Date, default: Date.now },
  updatedAt: { type: Date, default: Date.now }
};

export const createTransactionPayload = (cartItems, userData, paymentMethod, total) => {
  const items = cartItems.map(item => ({
    game_id: item.id,
    name: item.name,
    quantity: 1,
    totalparticipants: 1, // Default to 1 participant
    duration: parseInt(item.duration) || 60, // Default to 60 minutes
    price: item.price
  }));

  const subtotal = cartItems.reduce((sum, item) => sum + item.price, 0);
  // Tax removed — keep total equal to subtotal
  const finalTotal = +(subtotal).toFixed(2);

  return {
    player_name: userData.name,
    phone: parseInt(userData.phone),
    items,
    subtotal,
    discount_amount: 0,
    discount_percentage: 0,
    total: finalTotal,
    payment_status: paymentMethod === 'Pay at Counter' ? 'pending' : 'paid',
    payment_source: paymentMethod === 'Pay at Counter' ? 'cash' : 'online',
    invoice_number: `INV-${Date.now()}`,
    gameplayed: false
  };
};